const actions = {
  invoice: {titleKey: 'client.matters.matter_page.payments_tab.actions.invoice', svg: 'invoice', svg_tag: '24'},
  estimate: {titleKey: 'client.matters.matter_page.payments_tab.actions.estimate', svg: 'estimate', svg_tag: '24'},
  packages: {titleKey: 'client.matters.matter_page.payments_tab.actions.package', svg: 'package', svg_tag: '24'},
  products: {titleKey: 'client.matters.matter_page.payments_tab.actions.product', svg: 'product', svg_tag: '24'},
  accept_payment: {titleKey: 'client.matters.matter_page.payments_tab.actions.charge', svg: 'credit-card', svg_tag: '24'},
  record_payment: {titleKey: 'client.matters.matter_page.payments_tab.actions.record_payment', svg: 'payments', svg_tag: '24'},
  message: {titleKey: 'client.matters.matter_page.matter_tab.actions.message', svg: 'message', svg_tag: '24'},
  appointment: {titleKey: 'client.matters.matter_page.matter_tab.actions.appointment', svg: 'appointment', svg_tag: '24'},
  document: {titleKey: 'client.matters.matter_page.matter_tab.actions.document', svg: 'document', svg_tag: '24'},
  note: {titleKey: 'client.matters.matter_page.matter_tab.actions.note', svg: 'new-note', svg_tag: '24'},
  invite: {titleKey: 'client.matters.matter_page.matter_tab.actions.invite', svg: 'invite-via-email', svg_tag: '24'},
  register_to_event: {titleKey: 'client.action.register_to_event', svg: 'register-to-event', svg_tag: '24'},
  share_document: {titleKey: 'common.quick_actions_menu.share_document', svg: 'document', svg_tag: '24'},
  internal_document: {titleKey: 'common.quick_actions_menu.internal_document', svg: 'internal_document', svg_tag: '24'},
  request_signature: {titleKey: 'common.quick_actions_menu.request_signature', svg: 'request_signature', svg_tag: '24'}
};

const getActions = (...args) => {
  return args.filter(action => actions[action]).map(action => ({action: action, ...actions[action]}));
};

export default {
  getActions
}
